import Vue from 'vue'
import axios from 'axios'
import router from './router'
import env from './env.js'


//公共函数
//-----------------------------------------------------------------------------------------------
/**
 * 判断运行环境
 */
Vue.prototype.isDev = function () {

  if (process.env.NODE_ENV == 'development') return true;

  return false;

}

/**
 * 获取api域名
 */
Vue.prototype.getHost = function () {

  // return process.env.HOST;

  // if(Vue.prototype.isDev()) return Vue.prototype.getEnv('devHost')

  // return Vue.prototype.getEnv('proHost');

  return Vue.prototype.getEnv('host');

  // if (Vue.prototype.isDev()) return 'http://lv.com/api';

}

/**
 * 公共请求方法
 * @param {Object} params
 */
Vue.prototype.httpCommon = function (params) {

  params.baseURL = Vue.prototype.getHost();

  //是否显示加载遮罩层
  if (params.loading === true) {

    var loadForRequest = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });

  }


  params.headers = {
    'token': Vue.prototype.localGet('token'),
    // 'rule':Vue.$route.path
  };

  return new Promise((resolve, reject) => {

    axios(params).then((res) => {

      if (params.loading === true) loadForRequest.close();

      if (res.data.code >= 10 && res.data.code <= 50) {

        reject(res.data);

        return router.push('/login');
      }

      if (res.data.code >= 51 && res.data.code <= 100) {

        reject(res.data);

        return false;
        // return this.$message.error(res.data.msg);
      }


      //是否显示错误信息提示，一般返回code为1是成功，其他是失败

      if (res.data.code == 1) {

        resolve(res.data);

      } else {

        this.$notify({
          title: '错误',
          message: res.data.msg,
          position: 'bottom-right',
          type: 'error'
        });


        reject(res.data);


      }


    }).catch((e) => {

      this.$notify({
        title: '错误',
        message: e,
        position: 'bottom-right',
        type: 'error'
      });

      if (params.loading === true) {

        loadForRequest.close();

      }

      reject(e);

    });

  });

}

/**
 * get请求，数据用params
 * @param {Object} params
 */
Vue.prototype.httpGet = function (params) {


  params.method = 'get';

  return new Promise((resolve, reject) => {
    Vue.prototype.httpCommon(params).then((res) => {

      resolve(res);

    }).catch((res) => {
      reject(res);
    });

  });

}

/**
 * post请求，数据用data
 * @param {Object} params
 */
Vue.prototype.httpPost = function (params) {


  params.method = 'post';

  return new Promise((resolve, reject) => {
    Vue.prototype.httpCommon(params).then((res) => {

      resolve(res);

    }).catch((res) => {

      reject(res);
    });

  });


}


/**
 * 本地储存
 */
Vue.prototype.localSet = function (key, value, prefix = 'super_admin_') {

  localStorage.setItem(prefix + key, value);

}


/**
 * 本地储存获取
 */
Vue.prototype.localGet = function (key, defaultValue = '', prefix = 'super_admin_') {

  let re = localStorage.getItem(prefix + key);

  if (!re) return defaultValue;

  return re;

}

/**
 * 删除
 */
Vue.prototype.localRemove = function (key, prefix = 'super_admin_') {

  localStorage.removeItem(prefix + key);

}


/**
 * 克隆对象
 * @param {Object} object
 */
Vue.prototype.cloneObj = function (object) {

  return JSON.parse(JSON.stringify(object))
}


/**
 * item赋值
 * @param {Object} defaultItem
 * @param {Object} item
 */
Vue.prototype.setItem = function (defaultItem, item) {

  // console.log(item);
  for (let key in defaultItem) {

    // console.log(item[key]);

    // console.log(typeof(item[key]));
    if (!(typeof (item[key]) == 'undefined')) {

      // console.log(item[key]);
      defaultItem[key] = item[key];
    }

  }
}


Vue.prototype.messageCommon = function (title, message, type) {

  return new Promise((success, fail) => {

    this.$confirm(message, title, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: type
    }).then(() => {

      success();
    }).catch(() => {
      // console.log('fail');
      fail();
    });

  });

}


Vue.prototype.messageSuccess = function (title, message) {


  return new Promise((success, fail) => {

    Vue.prototype.messageCommon(title, message, 'success').then(() => {

      success();

    }).catch(() => {

      fail();

    });

  });


}


/**
 * 搜索跳转
 *
 * @param context  上下文对象（this）
 * @param query    传递参数
 * @param rememberQuery 是否保存其他参数
 */
Vue.prototype.routerSearch = function (context, query, rememberQuery = true) {

  let c = Vue.prototype.$AppContext;

  let path = c.$route.path;

  let pathTemp = c.cloneObj(path);

  let temp = c.$route.query;

  let queryTemp = c.cloneObj(temp);

  let oldQuery = c.cloneObj(temp);

  let str = '?';


  for (let key in query) {

    if (key == 'random') continue;

    let item = query[key];

    // oldQuery[key] = item;

    str += key + '=' + item + '&';


  }


  if (rememberQuery) {

    /**
     * 记住原有参数
     * @param {Object} let key in temp
     */
    for (let key in temp) {

      if (key == 'random') continue;

      if (findIndex(query, key)) continue;

      let item = temp[key];

      oldQuery[key] = item;

      str += key + '=' + item + '&';

    }

  }

  str = str.substr(0, str.length - 1);

  str = str + '&random=' + Math.random();

  c.$router.push(pathTemp + str);

  c.reloads();


}


function findIndex(array, index) {


  for (let key in array) {

    if (key == index) return true;


  }

  return false;

}

/**
 * 弹窗+ajax请求
 *
 * @param title 弹窗标题
 * @param message 弹窗内容
 * @param url 请求地址
 * @param data 请求数据
 *
 */
Vue.prototype.msgBoxAjax = function (title, message, url, data = {}, customClass = 'custom-class') {

  return new Promise((success, fail) => {

    let i = this.$msgbox({
      title: title,
      customClass: customClass,
      message: message,
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      // distinguishCancelAndClose:true
      closeOnClickModal: false,
      closeOnPressEscape: false,
      // closeOnHashChange: false,
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {

          console.log(instance);
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';

          this.httpPost({
            url: url,
            data: data
          }).then((re) => {
            // console.log(re);
            done();

            instance.confirmButtonLoading = false;


            i.responseData = re;


          }).catch(() => {
            instance.confirmButtonLoading = false;
            done();
          });


        } else {
          done();
        }
      }
    }).then((action, instance, done) => {

      if (action == 'confirm') {

        success(i.responseData);
      } else {


      }

    }).catch(() => {


      fail();

    });


  });


}


/**
 * 弹窗+ajax请求+自动显示错误弹窗
 *
 * @param title 弹窗标题
 * @param message 弹窗内容
 * @param url 请求地址
 * @param data 请求数据
 *
 */
Vue.prototype.msgBoxAjaxWithMessage = function (title, message, url, data = {}, customClass = 'custom-class') {

  return new Promise((success, fail) => {

    let i = this.$msgbox({
      title: title,
      customClass: customClass,
      message: message,
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      // distinguishCancelAndClose:true
      closeOnClickModal: false,
      closeOnPressEscape: false,
      // closeOnHashChange: false,
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {

          console.log(instance);
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';

          this.httpPost({
            url: url,
            data: data,
            showMessage: true
          }).then((re) => {
            // console.log(re);
            done();

            instance.confirmButtonLoading = false;


            i.responseData = re;


          }).catch(() => {
            instance.confirmButtonLoading = false;
            done();
          });


        } else {
          done();
        }
      }
    }).then((action, instance, done) => {

      if (action == 'confirm') {

        success(i.responseData);
      } else {


      }

    }).catch(() => {


      fail();

    });


  });


}


Vue.prototype.getEnv = function (key) {

  if (Vue.prototype.isDev()) return env['dev'][key];

  return env['pro'][key];
}

/**
 * 获取图片域名
 */
Vue.prototype.getImgPrefix = function () {

  let imgPrefix = Vue.prototype.getEnv('img_prefix');

  if (imgPrefix) return imgPrefix.replace(/\/?$/, '/');

  return Vue.prototype.getHost() + '/uploads/';
}

/**
 * 重置对象
 * @param {Object} obj
 */
Vue.prototype.resetObj = function (obj) {

  for (let i in obj) {

    switch (typeof obj[i]) {

      case 'number':

        obj[i] = 0;

        break;

      case 'string':

        obj[i] = '';

        break;

      case 'object':


        // obj[i]=[];

        if (obj[i] instanceof Array) {

          obj[i] = [];

          break;
        }

        if (obj[i] instanceof Object) {

          obj[i] = {};

          break;
        }

        obj[i] = '';


        break;

      default:


        obj[i] = '';


    }

  }
}


Vue.prototype.uploadFile = function (event, params = {}) {


  return new Promise((success, fail) => {

    let file = event.target.files;

    let form = new FormData();

    // form.append('file', file);

    //一个文件就是一个表单对象
    for (let i in file) {

      form.append('file' + i, file[i]);
    }

    //额外参数
    for (let i in params) {

      form.append(i, params[i]);

    }


    Vue.prototype.httpPost({
      url: "/admin/upload/upload",
      data: form
    }).then((re) => {


      if (re.code == 1) {

        success(re);
      } else {

        fail(re);
      }


    });

  });


}


Vue.prototype.getObj = function (obj, attr, defaultValue = '') {


  try {

    return eval('obj' + '.' + attr);

  } catch (e) {

    return defaultValue;
  }


}


//过滤器
//-----------------------------------------------------------------------------------------------

/**
 * 过滤分页数据
 */
Vue.filter('page', (value) => {

  if (!value) return 1;

  return Number(value);

});


/**
 * 保留两位小数（向下取整）
 */
Vue.filter('floor', (value) => {


  return Math.floor(value * 100) / 100;

});

Vue.filter('split', (value, index, delimiter = '.') => {

  try {

    if (!value) return '';

    return value.split(delimiter)[index];

  } catch (e) {

    console.error(e);

    return '';
  }

});



// WEBPACK FOOTER //
// ./src/common.js